import { api } from "@/api/axios.ts";
import { ApiOperationResult } from "@/types/common.types.ts";
import { ApiPagedData } from "@skailer-com/uikit/core";
import {
  ApiReminderHistory,
  ApiReminderHistoryFilter,
  ApiReminderSend,
} from "@/types/reminder.types.ts";

export const apiReminders = {
  send: async function (payload: ApiReminderSend) {
    return api.post<ApiOperationResult>("/api/v1/reminders/send", payload);
  },
  history: async function (filter: ApiReminderHistoryFilter) {
    return api.post<ApiPagedData<ApiReminderHistory>>("/api/v1/reminders/history/search", filter);
  },
};
